import { useInitialLoading } from '../hooks/useInitialLoading';
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { getAuthHeaders } from '../utils/authHeaders';

const NotificationsList = () => {
    const companyId = localStorage.getItem('selectedCompanyId');
    const authConfig = () => ({ headers: getAuthHeaders() });
    const [notifications, setNotifications] = useState([]);
    const [unreadCount, setUnreadCount] = useState(0);
    const [loading, setLoading] = useState(true);
  const initialLoading = useInitialLoading(loading);
    const [error, setError] = useState(null);

    const fetchAll = async () => {
        try {
            const res = await axios.get(`http://localhost:8000/api/companies/${companyId}/notifications`, authConfig());
            setNotifications(res.data.data);
            setUnreadCount(res.data.unread_count);
        } catch (err) {
            setError('Failed to fetch notifications.');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchAll();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [companyId]);

    const handleMarkRead = async (id) => {
        try {
            await axios.post(`http://localhost:8000/api/companies/${companyId}/notifications/${id}/read`, {}, authConfig());
            fetchAll();
        } catch (err) {
            alert('Error marking notification as read.');
        }
    };

    const handleMarkAllRead = async () => {
        try {
            await axios.post(`http://localhost:8000/api/companies/${companyId}/notifications/read-all`, {}, authConfig());
            fetchAll();
        } catch (err) {
            alert('Error marking all as read.');
        }
    };

    if (initialLoading) return <div className="p-6 text-center text-gray-600">Loading notifications...</div>;
    if (error) return <div className="p-6 text-center text-red-600">{error}</div>;

    return (
        <div className="max-w-4xl mx-auto p-6 mt-10">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                <h2 className="text-2xl font-bold text-gray-800">Notifications {unreadCount > 0 && <span className="text-sm font-normal text-blue-600">({unreadCount} unread)</span>}</h2>
                {unreadCount > 0 && (
                    <button onClick={handleMarkAllRead} className="text-sm text-blue-600 font-medium hover:underline">
                        Mark all as read
                    </button>
                )}
            </div>

            {notifications.length === 0 ? (
                <p className="text-gray-500 text-center mt-6">No notifications yet.</p>
            ) : (
                <div className="bg-white shadow-md rounded-lg divide-y divide-gray-100 mt-4">
                    {notifications.map((n) => (
                        <div
                            key={n.id}
                            onClick={() => !n.read_at && handleMarkRead(n.id)}
                            style={{ backgroundColor: n.read_at ? '#fff' : '#eff6ff', cursor: n.read_at ? 'default' : 'pointer' }}
                            className="px-4 py-3"
                        >
                            <div className="flex justify-between items-start">
                                <span className="text-xs font-semibold text-blue-700 uppercase">{n.type}</span>
                                <span className="text-xs text-gray-400">{new Date(n.created_at).toLocaleString()}</span>
                            </div>
                            <p className="text-sm text-gray-800 mt-1">{n.message}</p>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default NotificationsList;